/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_NewInputs */

const en_tasks_new = /** @type {(inputs: Tasks_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

const pt_br2_tasks_new = /** @type {(inputs: Tasks_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova atividade`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Tasks_NewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_new = /** @type {((inputs?: Tasks_NewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_NewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_new(inputs)
	return pt_br2_tasks_new(inputs)
});